export const sanitizePhone = (phone: string) => {
  if (!phone) return "";

  // Remove everything except digits
  const digits = String(phone).replace(/\D/g, "");

  // If it's 11 digits and starts with 505 (Nicaragua), take the last 8
  if (digits.length === 11 && digits.startsWith("505")) {
    return digits.slice(3);
  }

  // Return the digits found. This allows the UI to work during typing
  // and still provides a clean 8-digit number when the input is complete.
  return digits;
};

export const formatPhone = (phone?: string, countryCode?: number) => {
  if (!phone) return "";
  const draft = sanitizePhone(phone);
  if (!draft) return "";

  const newDraft = Array.from(draft);

  newDraft.splice(4, 0, "-");

  if (countryCode) {
    return `+(${countryCode}) ${newDraft.join("")}`;
  }

  return newDraft.join("");
};

export const sanitizePhoneForWhatsapp = (phone?: string | number) => {
  if (!phone) return "";

  const draft = String(phone).replace("-", "");

  if (draft.length < 8 || draft.length > 8) return "";

  return `+505${draft}`;
}

export const formatPhoneIntl = (phone?: string, countryCode: number = 505) => {
  if (!phone) return "";
  const draft = sanitizePhone(phone);
  if (!draft) return "";

  const newDraft = Array.from(draft);
  newDraft.splice(4, 0, "-");

  return `+${countryCode} ${newDraft.join("")}`;
};


